import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Snackbar, Typography, Alert } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Slide, { SlideProps } from '@mui/material/Slide';
import { TFunction } from 'i18next';
import React, { FC, useEffect, useState } from 'react';
import { infoUpdateType } from 'types/notifications';
import { buildSentence } from 'utils/notifications/content';

type TransitionProps = Omit<SlideProps, 'direction'>;

function TransitionDown(props: TransitionProps) {
  return <Slide {...props} direction="up" />;
}

type SnackBarTypes = {
  notification: infoUpdateType;
  t: TFunction;
};

const useStyles = makeStyles(() => ({
  alertContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  weightText: { fontWeight: 900 },
}));

const SnackBar: FC<SnackBarTypes> = ({ notification, t }) => {
  const [open, setOpen] = useState(true);
  const [previousNotification, setPreviousNotification] = useState(notification);

  const { name, kind, orderCode } = notification;
  if (notification !== previousNotification) {
    setPreviousNotification(notification);
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  };

  const classes = useStyles();

  const sentence = buildSentence(t, { name, kind });

  const message = orderCode ? `${orderCode}: ${sentence}` : sentence;

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      open={open}
      TransitionComponent={TransitionDown}
      key={1}
      autoHideDuration={3500}
      onClose={handleClose}
      data-screen-exclude
    >
      <Alert
        className={classes.alertContainer}
        icon={false}
        severity="success"
        action={
          <IconButton onClick={handleClose} color="inherit" size="large">
            <FontAwesomeIcon icon="times" />
          </IconButton>
        }
      >
        <Typography className={classes.weightText}>{message}</Typography>
      </Alert>
    </Snackbar>
  );
};

export default SnackBar;
